import React from 'react';
import { Link } from 'react-router-dom';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Badge from '@mui/material/Badge';

const SearchNav = ({ entityType, searchTerm, data }) => {

  let newEntityType = "";

  if(entityType=="My Profile") {
    newEntityType = "Contacts";
  } else if(entityType=="My Account") {
    newEntityType = "Accounts";
  } else {
    newEntityType = entityType;
  }

  const totalSize = data?.[newEntityType]?.totalSize || '0';

  return (
    <Link to={`/${newEntityType}/${searchTerm}`} style={{ textDecoration: 'none', color: 'inherit' }}>
      <ListItem>
        <ListItemText primary={entityType} />
        <Badge badgeContent={totalSize !== 0 ? totalSize : '0'} color="primary" max={5}>
        </Badge>
      </ListItem>
    </Link>
  );
};

export default SearchNav;
